export function getRandomFilename() {
  // Return current timestamp appended with random integer from 0 to 100
  const now = new Date()
  const random = Math.floor(Math.random() * 100)
  return `${now.getTime()}${random}`
}
